import { useEffect, useState } from 'react';
import { useIdentity } from './IdentityContext';

// Draft images require an Authorization header, which the shared public
// presentational components' plain <img src> can't send — pre-fetch each
// into an object URL here and return a synchronous accessor for it. `urlFn`
// builds the fetch URL from an image object (e.g. imageUrl or categoryImageUrl).
export default function useDraftImageUrls(images, urlFn) {
  const { authFetch } = useIdentity();
  const [objectUrls, setObjectUrls] = useState({});

  useEffect(() => {
    let cancelled = false;
    const pending = (images || []).filter((img) => img && !objectUrls[img.id]);
    pending.forEach((img) => {
      authFetch(urlFn(img))
        .then((r) => (r.ok ? r.blob() : null))
        .then((blob) => {
          if (cancelled || !blob) return;
          const objectUrl = URL.createObjectURL(blob);
          setObjectUrls((s) => ({ ...s, [img.id]: objectUrl }));
        })
        .catch(() => {});
    });
    return () => {
      cancelled = true;
    };
  }, [authFetch, images, urlFn, objectUrls]);

  return (image) => (image ? objectUrls[image.id] || '' : '');
}
